import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import SchoolProfileTemplate from '../components/SchoolProfileTemplate';

export default function SchoolProfile() {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            setError('');
            try {
                const [res, usersRes] = await Promise.all([
                    api.get(`/admin/api/schools/${id}`),
                    api.get('/admin/api/users')
                ]);
                const json = res.data;
                const users = usersRes.data;
                // build map id -> user
                const usersMap = {};
                if (Array.isArray(users)) {
                    users.forEach(u => { if (u && u.id != null) usersMap[u.id] = u; });
                }
                setData({ ...json, _usersMap: usersMap });
            } catch (err) {
                console.error(err);
                setError('Failed to load school profile');
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [id]);

    if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}><CircularProgress /></Box>;
    if (error) return <Alert severity="error">{error}</Alert>;

    return (
        <Box sx={{ width: '90%', margin: '32px auto' }}>
            <SchoolProfileTemplate
                school={{ schoolName: data?.schoolName, id: data?.id }}
                profile={data?.schoolProfile}
                cig={data?.cigApplication}
                ilg={data?.ilgApplication}
                usersMap={data?._usersMap}
            />
        </Box>
    );
}
